import React from "react";
import Dialog from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/styles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import FallBackImage from "../FallBackImage";
const useStyles = makeStyles(({
  breakpoints,
  palette,
  typography
}) => ({
  img: {
    maxHeight: typography.pxToRem(324),
    maxWidth: typography.pxToRem(318)
  },
  dialogContainer: {
    backgroundColor: palette.background.modal,
    alignItems: "center"
  },
  imgContainer: {
    display: "flex",
    position: "relative",
    minHeight: typography.pxToRem(50),
    minWidth: typography.pxToRem(50),
    border: `${typography.pxToRem(1)} solid ${palette.border.iconBlock}`,
    [breakpoints.down("xs")]: {
      margin: typography.pxToRem(25)
    },
    [breakpoints.up("sm")]: {
      margin: typography.pxToRem(36)
    }
  },
  closeButton: {
    position: "absolute",
    right: 0,
    top: 0,
    color: palette.border.iconBlock
  }
}));

const ImageDialog = ({
  src,
  open,
  onClose
}) => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement(Dialog, {
    open: open,
    onClose: onClose,
    classes: {
      paper: styles.dialogContainer
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "close",
    size: "small",
    className: styles.closeButton,
    onClick: onClose
  }, /*#__PURE__*/React.createElement(CloseIcon, null)), /*#__PURE__*/React.createElement(Grid, {
    className: styles.imgContainer
  }, /*#__PURE__*/React.createElement(FallBackImage, {
    src: src,
    alt: "",
    className: styles.img
  })));
};

export default ImageDialog;